import api from './api';

export const referralService = {
  // 1. Referral Sources
  getSources: async (params = {}) => {
    const response = await api.get('/referral-sources', { params });
    return response.data;
  },

  getSourceById: async (id) => {
    const response = await api.get(`/referral-sources/${id}`);
    return response.data;
  },

  createSource: async (data) => {
    const response = await api.post('/referral-sources', data);
    return response.data;
  },

  updateSource: async (id, data) => {
    const response = await api.put(`/referral-sources/${id}`, data);
    return response.data;
  },

  updateSourceStatus: async (id, isActive) => {
    const response = await api.patch(`/referral-sources/${id}/status`, isActive, {
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  },

  // 2. Share Configurations
  getShareConfigs: async (params = {}) => {
    const response = await api.get('/referral-shares', { params });
    return response.data;
  },

  getShareConfigById: async (id) => {
    const response = await api.get(`/referral-shares/${id}`);
    return response.data;
  },

  createShareConfig: async (data) => {
    const response = await api.post('/referral-shares', data);
    return response.data;
  },

  updateShareConfig: async (id, data) => {
    const response = await api.put(`/referral-shares/${id}`, data);
    return response.data;
  },

  updateShareConfigStatus: async (id, isActive) => {
    const response = await api.patch(`/referral-shares/${id}/status`, isActive, {
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  },

  copyShareConfig: async (data) => {
    const response = await api.post('/referral-shares/copy', data);
    return response.data;
  },

  transferShare: async (data) => {
    const response = await api.post('/referral-shares/transfer', data);
    return response.data;
  },

  // 3. Commission Ledger
  getCommissionLedger: async (params = {}) => {
    const response = await api.get('/referral-settlements/ledger', { params });
    return response.data;
  },

  getLedger: async (params = {}) => {
    const response = await api.get('/referral-settlements/ledger', { params });
    return response.data;
  },

  // 4. Settlements
  getSettlements: async (params = {}) => {
    const response = await api.get('/referral-settlements', { params });
    return response.data;
  },

  getSettlementDetail: async (id) => {
    const response = await api.get(`/referral-settlements/${id}`);
    return response.data;
  },

  getSettlementById: async (id) => {
    const response = await api.get(`/referral-settlements/${id}`);
    return response.data;
  },

  createSettlement: async (data) => {
    const response = await api.post('/referral-settlements', data);
    return response.data;
  },

  createAdjustment: async (data) => {
    const response = await api.post('/referral-settlements/adjustments', data);
    return response.data;
  },

  // 5. Reports & Statements
  getDoctorStatement: async (params = {}) => {
    const response = await api.get('/referral-reports/statement', { params });
    return response.data;
  },

  getCentres: async () => {
    const response = await api.get('/centres');
    return response.data;
  },
};

export default referralService;
